import ExploreServiceSort from '../types/ExploreServiceSort';

export const defaultExploreServiceSort: ExploreServiceSort = 'best_match';

export const maxHitsPerRequest = 1000;
export const exploreServiceSortDisplayOrder: ExploreServiceSort[] = ['best_match', 'most_popular', 'closest', 'seasonal', 'newly_added'];

/**
 * Valid attributes for explore-service
 * Source of truth: explore-service/app/contracts/explore/enum_values.rb (VALID_RECORD_ATTRIBUTES)
 */
export const validExploreServiceAttributes = new Set([
  '_geoloc',
  '_cluster_geoloc',
  'activities',
  'area_id',
  'area_name',
  'area_slug',
  'area_type',
  'associated_area_ids',
  'avg_rating',
  'background_color',
  'city_name',
  'city_url',
  'country_name',
  'created_at',
  'difficulty_rating',
  'duration_minutes',
  'duration_minutes_hiking',
  'duration_minutes_trail_running',
  'duration_minutes_mountain_biking',
  'duration_minutes_cycling',
  'elevation_gain',
  'elevation_meters',
  'estimated_time_to_complete',
  'exclude',
  'features',
  'filters',
  'has_guides',
  'has_profile_photo',
  'ID',
  'indexed_at',
  'is_closed',
  'lat',
  'length',
  'location_type',
  'lng',
  'name',
  'num_photos',
  'num_reviews',
  'objectID',
  'overview',
  'photo_url',
  'poi_count',
  'popularity',
  'popularity_by_month',
  'primary_trailhead_id',
  'profile_photo_url',
  'seasonal_popularity',
  'secondary_trailhead_ids',
  'route_type',
  'trail_count',
  'trail_ids',
  'type',
  'verified_map_id',
  'short_name',
  'source',
  'slug',
  'state_name',
  'subtype',
  'location_label',
  'type_label',
  'collections',
  'boundary_path',
  'trails_count',
  'collections_with_photos',
  'park_download',
  'is_interactive',
  'description',
  'photos_count',
  'polyline'
]);
